import type { ModuloWeb } from '../../nucleo/modulos-web';
import { buscaAusencias } from './busca-global';
import { Calendario } from './Calendario';
import { i18n } from './i18n';
import { Aprovacoes, Pedidos } from './Pedidos';
import { Saldos } from './Saldos';
import { Tipos } from './TiposAusencia';

/** Pacote 2 (onda 1a): Férias e ausências, no menu Pessoas. */
const modulo: ModuloWeb = {
  slug: 'ausencias',
  menu: 'pessoas',
  ordem: 30,
  abas: [
    { chave: 'pedidos', permissao: 'ausencias.ver', componente: Pedidos },
    { chave: 'aprovacoes', permissao: 'ausencias.aprovar', componente: Aprovacoes },
    { chave: 'calendario', permissao: 'ausencias.ver', componente: Calendario },
    { chave: 'saldos', permissao: 'ausencias.ver', componente: Saldos },
    { chave: 'tipos', permissao: 'ausencias.ver', componente: Tipos },
  ],
  i18n,
  buscaGlobal: buscaAusencias,
};

export default modulo;
